import { render, staticRenderFns } from "./TaskFormatsFormUpdate.vue?vue&type=template&id=37f92cfc&scoped=true"
import script from "./TaskFormatsFormUpdate.vue?vue&type=script&lang=js"
export * from "./TaskFormatsFormUpdate.vue?vue&type=script&lang=js"
import style0 from "./TaskFormatsFormUpdate.vue?vue&type=style&index=0&id=37f92cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f92cfc",
  null
  
)

export default component.exports